import { useCallback } from 'react';
import { useGetEmissorOrderPaymentPdfMutation, } from '../services/contractOrderPaymentApi';
export function useEmissorOrderPaymentPdf() {
    const [trigger, { isLoading }] = useGetEmissorOrderPaymentPdfMutation();
    const getOrderPaymentPdf = useCallback((params) => trigger(params).unwrap(), [trigger]);
    return { getOrderPaymentPdf, isLoading };
}
